import { useMemo } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import {
  PaginatedOrgsTable,
  useOrgColumns,
  useFDRFieldCountColumn,
  useFDRAcresColumn,
} from '@cibo/profile'
import { FDRStatus } from '@cibo/core'
import { ADMIN_ROUTES, AdminProgramRouteParams } from 'navigation/types'

export const ProgramOrganizationList = () => {
  const { programId } = useParams<AdminProgramRouteParams>()
  const navigate = useNavigate()

  const allOrgColumns = useOrgColumns()

  const fdrColumns = [
    useFDRFieldCountColumn(FDRStatus.enrolling),
    useFDRAcresColumn(FDRStatus.enrolling),
    useFDRFieldCountColumn(FDRStatus.enrolled),
    useFDRAcresColumn(FDRStatus.enrolled),
  ]

  const organizationColumns = useMemo(
    () => [allOrgColumns.name, ...fdrColumns, allOrgColumns.fieldCount, allOrgColumns.acres],
    []
  )

  return (
    <PaginatedOrgsTable
      programId={programId}
      columns={organizationColumns}
      headerPaletteColor="primary"
      onRowClick={({ id }) =>
        navigate(
          generatePath(ADMIN_ROUTES.PROGRAM_ORGANIZATION_DETAIL, {
            programId,
            organizationId: id as string,
          })
        )
      }
      routeKey="foobar"
    />
  )
}
